import { useState } from "react";
import { useMotionValueEvent } from "framer-motion";
import { useScrollCtx } from "@/providers/AppProviders";
import { content } from "@/lib/content";

const centers = [0.06, 0.22, 0.4, 0.57, 0.74, 0.93];

export const FrameIndicator = () => {
  const { progress, scrollToProgress } = useScrollCtx();
  const [idx, setIdx] = useState(0);

  useMotionValueEvent(progress, "change", (v) => {
    let best = 0;
    let bd = 1;
    centers.forEach((c, i) => {
      const d = Math.abs(c - v);
      if (d < bd) {
        bd = d;
        best = i;
      }
    });
    setIdx(best);
  });

  return (
    <div className="fixed right-6 top-1/2 z-[60] hidden -translate-y-1/2 flex-col items-end gap-4 md:flex sm:right-8">
      {content.frames.map((label, i) => (
        <button
          key={label}
          onClick={() => scrollToProgress(centers[i])}
          data-cursor="hover"
          className="group flex items-center gap-3"
          aria-label={label}
        >
          <span
            className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground opacity-0 transition-opacity duration-300 group-hover:opacity-80"
          >
            {label}
          </span>
          <span
            className={`block rounded-full transition-all duration-300 ${
              idx === i
                ? "h-3 w-3 bg-primary"
                : "h-1.5 w-1.5 bg-muted-foreground/50 group-hover:bg-muted-foreground"
            }`}
          />
        </button>
      ))}
    </div>
  );
};
